import * as React from "react";
import { IconProps } from "./IconProps";

export const IconDraggable = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="6"
        height="10"
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Group 2960">
          <circle id="Ellipse 33" cx="1" cy="1" r="1" fill="#66788C" />
          <circle id="Ellipse 34" cx="5" cy="1" r="1" fill="#66788C" />
          <circle id="Ellipse 35" cx="5" cy="5" r="1" fill="#66788C" />
          <circle id="Ellipse 36" cx="1" cy="5" r="1" fill="#66788C" />
          <circle id="Ellipse 37" cx="1" cy="9" r="1" fill="#66788C" />
          <circle id="Ellipse 38" cx="5" cy="9" r="1" fill="#66788C" />
        </g>
      </svg>
    );
  }
);
